<template>
    <div :id="'wechat-web-container'+params.id"
         v-if="!hasPC"
         :class="diySetting?diySetting.className:'wxlite'" v-on:click="!hasOpenLaunchFlag && OpenLite()">{{diySetting?diySetting.buttonName:'查看详情'}}</div>
</template>
<script>
  import App from '../util/comfun'
  export default {
    props:{
      path:{
        type:String,
        value:'',
      },
      params:{
        type:Object,
        value:null,
      },
      share:{
        type:Object,
        value:null,
      },
      diySetting:{
        type:Object,
        value:null,//{className:'cla-41458-43393',buttonName:'我要投文稿',}
      },
      vipType:{
        type:Number,
        value:0,
      }
    },
    data(){
      return {
        hasOpenLaunchFlag:false,
        hasPC:false,
      }
    },
    methods: {
      hasOpenLaunch(){
        this.hasOpenLaunchFlag=this.is_weixn() && this.is_version()
        return this.hasOpenLaunchFlag
      },
      is_weixn() {
        let ua = navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          return true
        } else {
          return false
        };
      },
      is_version(){
        let client = false; // 当前版本号是否支持 (默认不支持)
        let wxInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i); // 微信浏览器信息
        // 微信版本号 wxInfo[1] = "7.0.18.1740" (示例)
        //进行split转成数组进行判断 [7,0,18,1740] (示例)
        console.log('wxInfo',wxInfo)
        let version = wxInfo[1].split(".");
        // 判断版本在7.0.12及以上的版本
        if (version[0] >= 7) {
          if (version[1] >= 0 || version[0] > 7) {
            if (version[2] >= 12 || version[0] > 7 || version[1] > 0) {
              client = true; // 当前版本支持
            }
          }
        }
        return client;
      },
      is_mobile(){
        return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i.test(navigator.userAgent)
      },
      displayWxButton(){
        let buttonName=this.diySetting?this.diySetting.buttonName:'查看详情'
        let className=this.diySetting?this.diySetting.className:'wxlite'
        let content = `
      <div class="${className}">${buttonName}</div>
      <style>
        .wxlite{
            width: 295px;
            height: 35px;
            opacity: 1;
            background: #3dc4a7;
            border-radius: 18px;

            opacity: 1;
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: center;
            color: #ffffff;
            line-height: 35px;
            text-align: center;
            margin: 0 auto;
        }
        .cla-41458-43393{
            width: 87px;
            height: 23px;
            background: #f1c47d;
            border-radius: 11px;
            font-size: 13px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: center;
            color: #8c1e22;
            line-height: 23px;
            letter-spacing: 0.26px;
        }
        .cla-179375{
            width: 175.2px;
            height: 34.8px;
            background-image: url("https://assets.pfotoo.com/179375/button-bg.png");
            background-size: 100% 100%;

            font-weight: 700;
            font-size: 15.2px;
            text-align: center;
            color: #057956;
            letter-spacing: 0.4px;
            line-height: 34.8px;
        }
        .wxlite-welcome{
            width: 315px;
        }
      </style>
      `;

        let launchParams = {
          eleId:"wechat-web-container"+this.params.id, // 元素id
          url: "pages/enter/enter.html", // 跳转小程序的页面路径
          content:content // 自定义的html内容
        };
        let yuanshiID='gh_060eb937b274'
        if(this.vipType>20){//企业版
          yuanshiID='gh_1991d75b91cd'
        }
        launchParams.url=App.http_build_query(this.params,this.path+'.html')
        var btn = document.getElementById(launchParams.eleId); //获取元素
        let script = document.createElement("script");// 创建script内容插槽 避免template标签冲突
        script.type = "text/wxtag-template"; // 使用script插槽 必须定义这个type
        script.text = launchParams.content // 自定义的html字符串内容
        let html = `<wx-open-launch-weapp style="width:100%;display:block;" username="${yuanshiID}" path="${launchParams.url}">${script.outerHTML}</wx-open-launch-weapp>`;
        btn.innerHTML = html; // html字符串赋值
        // 点击按钮 正常跳转触发
        btn.addEventListener("launch", function (e) {
          console.log("success");
        });
        // 点击跳转 抛出异常
        btn.addEventListener("error", function (e) {
          console.log("fail", e.detail);
          alert(`跳转异常 - ${e.detail}`)
        });
      },
      displayButton(){
        if(this.hasOpenLaunch()) {//微信环境
          this.displayWxButton()
        }else if(this.is_mobile()){//手机端其它浏览环境
          this.cloudInit()
        }else{//PC 环境
          this.hasPC=true
        }

      },
      /////云函数香菇干
      async cloudInit(){
        const res = await App.Activity.generateUrlSchema({
          "appId": this.vipType>20?'wxb85ef06b22c33674':'wx397090124c858e7c',
          "expireInterval": "",
          "expireTime": parseInt(new Date()/1000+86400*30),
          "expireType": 0,
          "params": App.http_build_query(this.params,''),
          "path": this.path,
          "envVersion":location.href.indexOf('--DEBUG--')>-1?"develop":"release",
        })
        /*
        this.cloud = new cloud.Cloud({
          // 必填，表示是未登录模式
          identityless: true,
          // 资源方 AppID
          resourceAppid: 'wx397090124c858e7c', // <!-- replace -->
          // 资源方环境 ID
          resourceEnv: 'fotoo-8gcyg8ej83e3a066', // <!-- replace -->
        })
        await this.cloud.init()
        //console.error('cloudInit',this.cloud)
        const res = await this.cloud.callFunction({
          name: 'public',
          data: {
            action: 'getUrlScheme',
            path:this.path,
            params:this.params,
          },
        })
        */
        //console.error('getUrlScheme',res)
        this.openlink=res.data.openlink
        console.log('this.openlink',this.openlink)
        //location.href = res.result.openlink

      },
      OpenLite(){
        if(!this.openlink) return setTimeout(()=>{this.OpenLite()},1000);
        console.log('location.href = this.openlink', this.openlink)
        location.href = this.openlink
      },
    },
    created(){
      if(this.is_weixn()){
        let jsApiList=[
          'checkJsApi',
          "onMenuShareAppMessage", // 分享给朋友
          "onMenuShareTimeline", // 分享到朋友圈
          //"onMenuShareQQ", // 分享到QQ
          //"onMenuShareQZone", // 分享到QQ空间
          'hideOptionMenu','hideMenuItems','hideAllNonBaseMenuItem'
        ]
        wx.config({
          debug: false,
          appId: 'wx397090124c858e7c', // <!-- replace -->
          timestamp: parseInt(new Date()/1000), // 必填，填任意数字即可
          nonceStr: 'nonceStr', // 必填，填任意非空字符串即可
          signature: 'signature', // 必填，填任意非空字符串即可
          //需要微信权限列表
          jsApiList: jsApiList,
          openTagList:['wx-open-launch-weapp'] // 微信开放标签 小程序跳转按钮：<wx-open-launch-weapp>
        });
        //console.log(location.href)
        wx.ready(()=>{
          let obj={
            title: this.share.title, // 分享标题
            desc: this.share.desc||'',
            //link: '{$url}__URL__/index?pid={$pid}&puid={$uid}', // 分享链接,将当前登录用户转为puid,以便于发展下线
            link:location.href,
            imgUrl: this.share.thumb, // 分享图标
            success: function () {
              // 用户确认分享后执行的回调函数
              alert('分享成功');
            },
            cancel: function () {
              // 用户取消分享后执行的回调函数
              alert('cancel');
            }
          }
          if(this.diySetting && this.diySetting.hideShareMenu){
            wx.hideOptionMenu && wx.hideOptionMenu()
            wx.hideMenuItems && wx.hideMenuItems()
            wx.hideAllNonBaseMenuItem && wx.hideAllNonBaseMenuItem()
          }else{
            wx.onMenuShareTimeline(obj);
            wx.onMenuShareAppMessage(obj)
          }
        });
      }
    },
    mounted(){
        this.displayButton()
    },
  }
</script>
<style scoped>
    .wxlite{
        width: 295px;
        height: 35px;
        opacity: 1;
        background: #3dc4a7;
        border-radius: 18px;

        opacity: 1;
        font-size: 14px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 35px;
        text-align: center;
        margin: 47px auto 0;
    }
    .cla-41458-43393{
        width: 87px;
        height: 23px;
        background: #f1c47d;
        border-radius: 11px;
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: center;
        color: #8c1e22;
        line-height: 23px;
        letter-spacing: 0.26px;
    }
    .cla-179375{
        width: 175.2px;
        height: 34.8px;
        background-image: url("https://assets.pfotoo.com/179375/button-bg.png");
        background-size: 100% 100%;

        font-weight: 700;
        font-size: 15.2px;
        text-align: center;
        color: #057956;
        letter-spacing: 0.4px;
        line-height: 34.8px;
    }
    .wxlite-welcome{
        width: 315px;
    }
</style>


// WEBPACK FOOTER //
// src/components/jump-button.vue